import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Info from './Info';

const MessagebarContainer = styled.div(({ theme: { secondaryColor, primaryColor, mobile } }) => ({
  background: secondaryColor,
  color: primaryColor,
  padding: '4px 40px',
  borderRadius: 10,
  textAlign: 'center',
  marginTop: 16,
  fontSize: 12,
  fontWeight: 600,
  button: {
    verticalAlign: 'middle',
  },
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  [`@media ${mobile}`]: {
    textAlign: 'left',
    padding: '8px 16px',
    justifyContent: 'space-between',
  }
}));

const Messagebar = ({ children, modalText, modalTitle, ...props }) => (
  <MessagebarContainer {...props}>
    {children}
    {modalText && <Info title={modalTitle}>{modalText}</Info>}
  </MessagebarContainer>
);

Messagebar.propTypes = {
  children: PropTypes.node.isRequired,
  modalText: PropTypes.string,
  modalTitle: PropTypes.string,
};

Messagebar.defaultProps = {
  modalText: '',
  modalTitle: '',
};

export default Messagebar;
